<template>

  <div>

    <div>
      <div class="titleRow">
        <div class="circleYellow"></div>
        <div class="titleText">{{$t('track.tableLabel.demandInformation')}}</div>
      </div>
    </div>


    <div class="demandInformation_div">
      <a-row>
        <a-col :span="6">
          <div class="item">
            <div class="title">{{$t('track.tableLabel.expectStartDate')}}</div>
            <div class="value">{{detail.expectStartDate | dayjs('YYYY-MM')}}</div>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="item">
            <div class="title">{{$t('track.tableLabel.type')}}</div>
            <div class="value_1">{{$t('track.trackType.' + detail.pursuitsType)}}</div>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="item">
            <div class="title">{{$t('track.tableLabel.area')}}</div>
            <div class="value_1">
              {{detail.demandArea | NumberFormat}}
              <pt-unit-select type="area" v-model="detail.demandAreaUnit" :edit-mode="false"></pt-unit-select>
            </div>
          </div>
        </a-col>
        <a-col :span="6">
          <div class="item">
            <div class="title">{{$t('track.trackModal.propertyTypeLabel')}}</div>
            <div class="value_1">
              {{detail.propertyType}}
            </div>
          </div>
        </a-col>

        <a-col :span="24">
          <div class="item">
            <div class="title">{{$t('track.trackModal.remarksLabel')}}</div>
            <div class="value_1">
              {{detail.remarks}}
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
  </div>



</template>

<script>
export default {
  name: 'demandInformation',
  props:{
    detail:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  mounted() {
    console.log('detail',this.detail)
  }

}




</script>

<style scoped lang="less">
.demandInformation_div{
  background: #fafbfc;
  padding: 20px 24px;
  margin-top: 5px;
  margin-bottom: 30px;
  .item{
    margin-bottom: 20px;
  }
  .title{
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
  }
  .value{
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;

  }
  .value_1{
    font-size: 12px;
    letter-spacing: 0;
  }


}

.titleRow{
  background: #FAFBFC;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 5px;
  .circleYellow{
    width: 12px;
    height: 12px;
    background: #FABE00;
    border-radius: 50%;
    margin: 0 10px;
  }
  .titleText{
    font-size: 14px;
    color: #333333;
    font-weight: bold;
  }
}


</style>